import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CreateAuthorService {
  private baseUrl = `${env.apiCerberoUrl}`;
  httpClient: any;

  constructor(private http: HttpClient) { }

  listAuthors(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/request?event=listar-autores`);
  }

  createAuthor(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/request?event=crear-autor`, payload);
  }

  uploadPhoto(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('app', 'RedaccionApp');
    return this.http.post<any>(`${this.baseUrl}/upload-file`, formData);
  }

  deleteAuthor(id: number) {
    return this.http.delete<any>(`/api/autores/${id}`);
  }  

  updateAuthor(payload: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/request?event=actualizar-autor`, payload);
  }  

}
